import { useEffect } from 'react';
import { useUIStore, useItemsStore, useOrdersStore } from '../store';
import { useRestaurantSlug } from './useRestaurantSlug';
import { useRestaurantMetadata } from './useRestaurantMetadata';
import { useSelectedMode } from './useSelectedMode';
import { useMenuData } from './useMenuData';
import { useVisualContent } from './useVisualContent';
import { useRestaurantConfig } from './useRestaurantConfig';

export const useRestaurantData = () => {
  const slug = useRestaurantSlug();
  const { data: restData, loading: loadingMeta, error: metaError } = useRestaurantMetadata(slug);

  const selectedMode = useSelectedMode(restData);

  const assetsVersionIso = restData?.last_published_at ?? restData?.updated_at ?? null;
  const assetsVersionMs = assetsVersionIso
    ? String(new Date(assetsVersionIso).getTime())
    : '1';

  const { assetsLoading, menuError, menuPending } = useMenuData(restData?.id, assetsVersionIso, selectedMode);
  useVisualContent(restData?.id, selectedMode);
  const config = useRestaurantConfig(restData, assetsVersionMs);

  // Reset stores al cambiar restaurante o modo
  const setMenuStore = useItemsStore((s) => s.setMenu);
  const setFeaturesStore = useItemsStore((s) => s.setFeatures);
  const setCarouselContentStore = useItemsStore((s) => s.setCarouselContent);
  const setHasFilter = useItemsStore((s) => s.setHasFilter);
  useEffect(() => {
    setMenuStore({ categories: [] });
    setFeaturesStore([]);
    setCarouselContentStore([]);
    setHasFilter(false);
  }, [restData?.id, selectedMode, setMenuStore, setFeaturesStore, setCarouselContentStore, setHasFilter]);

  // Sync carrito y sección según modo
  const setCanUseCart = useOrdersStore((s) => s.setCanUseCart);
  const setSection = useUIStore((s) => s.setSection);
  useEffect(() => {
    const enabled = selectedMode === 'DELIVERY';
    setCanUseCart(enabled);
    if (!enabled) setSection('home');
  }, [selectedMode, setCanUseCart, setSection]);

  return {
    config,
    loading: loadingMeta || assetsLoading || menuPending,
    selectedMode,
    error: metaError || menuError,
  };
};
